/* src/app/job-signoff-artic/pages/job-signoff-artic-view/job-signoff-artic-view.component.scss */
/*# sourceMappingURL=job-signoff-artic-view.component.css.map */
